import BaseModal from 'flow/components/ui-components/BaseModal';
import useAppContext from 'flow/hooks/useAppContext';

/**
 * Tells the user that the backend refused what they just asked for.
 *
 * Opened by useTicketAction, which is the one place a refused ticket action is
 * recognised. Nothing here is ticket-specific, so anything else that meets a
 * refusal can open it too.
 */
const AccessDeniedDialog = () => {
    const { i18next } = useAppContext();

    return (
        <BaseModal
            open={true}
            header={i18next.t('access_denied.title')}
            onSubmit={() => {}}
            // BaseModal's own default is "Save", which is not what dismissing a
            // message does.
            confirmButtonText={i18next.t('ok')}
            hideCancelButton={true}
        >
            {i18next.t('tickets.no_permission')}
        </BaseModal>
    );
};

export default AccessDeniedDialog;
